import React from 'react';
import {createBrowserRouter, Outlet, RouterProvider} from "react-router-dom";
import {Helmet} from "react-helmet";


import './App.css';
import './Homepage.css'; 
import Home from './pages/Home';
import Create from './pages/Create';
import Login from './pages/Login';
import Post from './pages/Post';
import Register from './pages/Register';
import Samples from './pages/Samples';
import Footer from './components/Footer';
import Header from './components/Header';
import Order from './pages/Order';
import Mdadminpage from './pages/Mdadminpage';
import Scrolltotop from './components/Scrolltotop';
import Terms from './pages/Terms';
import Privacypolicy from './pages/Privacypolicy';
import Bsn from './pages/Nursing/Bsn';
import Msn from './pages/Nursing/Msn';
import Dnp from './pages/Nursing/Dnp';
import Bspsy from './pages/Psychology/Bspsy';
import Bspsypre from './pages/Psychology/Bspsypre';
import Msapplied from './pages/Psychology/Msapplied';
import Msclinical from './pages/Psychology/Msclinical';
import Mspsy from './pages/Psychology/Mspsy';
import Msschool from './pages/Psychology/Msschool';
import Edsschool from './pages/Psychology/Edsschool';
import Phdbehaviour from './pages/Psychology/Phdbehaviour';
import Phdpsyc from './pages/Psychology/Phdpsyc';
import Psydclinical from './pages/Psychology/Psydclinical';
import Psydschool from './pages/Psychology/Psydschool';
import Service from './pages/Services/Service';
import Thankyou from './pages/Thankyou';
import CapellaFlexpath from './pages/Services/CapellaFlexpath';
import MsnFlexpath from './pages/Services/MsnFlexpath';
import Dnpflexpath from './pages/Services/Dnpflexpath';
import CapellacapstoneBsn from './pages/Services/Capellacapstonebsn';
import Nursingdissertation from './pages/Services/Nursingdissertation';
import CapellaFlexPathAssisstance from './pages/Services/Capellaflexpathassisstance';
import DNPCapstoneProjectHelp from './pages/Services/Dnpcapstoneprojecthelp';
import DNPDissertationHelp from './pages/Services/DNPdissertationhelp';
import CapellaUniversityHelp from './pages/Services/Capellauniversityhelp';
import ReliableNursingHomeworkHelp from './pages/Services/Reliablenursinghomeworkhelp';
import BoostAcademicPerformance from './pages/Services/Boostacademicperformance';
import TakeMyOnlineClass from './pages/Services/Takemyonlineclass';
import AcademicAssignmentHelp from './pages/Services/Academicassignmenthelp';
import AssignmentWritingServices from './pages/Services/Assignmentwritingservices';
import NursingAssignment from './pages/Services/Nursingassignment';
import CheapAssignmentWriting from './pages/Services/Cheapassignmentwriting ';
import DoMyAssignment from './pages/Services/Domyassignment ';
import OnlineNursingClass from './pages/Services/Onlinenursingclass';
import Hiresomeonetdoyourclass from './pages/Services/Hiresomeonetdoyourclass';
import DoMyClass from './pages/Services/Domyclass';
import OnlineClassHelp from './pages/Services/Onlineclasshelp';
import TakeMyClassOnline from './pages/Services/Takemyclassonline';
import Paysomeonetotakemyclass from './pages/Services/Paysomeonetotakemyclass';
import Searchingforaperson from './pages/Services/Searchingforaperson';
import TakeMyOnlineCourse from './pages/Services/Takemyonlinecourse';
import Unlockingacademicsuccess from './pages/Services/Unlockingacademicsuccess';
import Paytotakemyonlineclass from './pages/Services/Paytotakemyonlineclass';
import Paysomeonetotakeonlineclasses from './pages/Services/Paysomeonetotakeonlineclasses';
import Domyclassforme from './pages/Services/Domyclassforme';
import Mbafpx5002mbaleadership from './pages/Services/Mbafpx5002mbaleadership';
import Mbafpx5006businessstrategy from './pages/Services/Mbafpx5006businessstrategy';
import Mbafpx5008appliedbusinessanalytics from './pages/Services/Mbafpx5008appliedbusinessanalytics';
import Mba5010accountingmethodsforleaders from './pages/Services/Mba5010accountingmethodsforleaders';
import Mbafpx5012marketingmanagement from './pages/Services/Mbafpx5012marketingmanagement';
import Mbafpx5014appliedmanagerialfinance from './pages/Services/Mbafpx5014appliedmanagerialfinance';
import Mbafpx5016operationsmanagementforleaders from './pages/Services/Mbafpx5016operationsmanagementforleaders';
import Mhafpx5001 from './pages/Services/Mhafpx5001';
import Mhafpx5006 from './pages/Services/Mhafpx5006';
import Mhafpx5010 from './pages/Services/Mhafpx5010';

import NURSFPX4060 from './pages/Samples/Nursfpx4060';
import Nursfpx from './pages/Samples/Nursfpx';
import Nursfpx4050assessment1 from './pages/Samples/Nursfpx4050assessment1';
import Nursfpx4050assessment2 from './pages/Samples/Nursfpx4050assessment2';
import Nursfpx4060assessment4 from './pages/Samples/Nursfpx4060assessment4';
import Nursfpx4060assessment2 from './pages/Samples/Nursfpx4060assessment2';
import Nursfpx4020assessment4 from './pages/Samples/Nursfpx4020assessment4';
import Nursfpx4000assessment2 from './pages/Samples/Nursfpx4000assessment2';
import Nursfpx4030assessment1 from './pages/Samples/Nursfpx4030assessment1';
import Nursfpx4030assessment2 from './pages/Samples/Nursfpx4030assessment2';
import Nursfpx4000assessment1 from './pages/Samples/Nursfpx4000assessment1';
import Nursfpx4900assessment2 from './pages/Samples/Nursfpx4900assessment2';
import Mhafpx5006A1 from './pages/Samples/Mhafpx5006A1';
import Mhafpx5006A2 from './pages/Samples/Mhafpx5006A2';
import Mhafpx5006A3 from './pages/Samples/Mhafpx5006A3';
import Mhafpx5006A4 from './pages/Samples/Mhafpx5006A4';
import Mhafpx5012 from './pages/Services/Mhafpx5012';
import Mhafpx5014 from './pages/Services/Mhafpx5014';
import Nursfpx8030a2 from './pages/Samples/Nursfpx8030a2';
import Nursfpx8014a1 from './pages/Samples/Nursfpx8014a1';
import Nursfpx8014a2 from './pages/Samples/Nursfpx8014a2';
import Nursfpx6614a1 from './pages/Samples/Nursfpx6614a1';



const Layout = ()=>{
    return(
        <>
        <Scrolltotop/>
        <Header />
        <Outlet />
        <Footer />
        </>
    )
}

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout/>,
      children: [
        {
            path: "/",
            element: <Home />
        },
        {
            path: "/samples",
            element: <Samples />
        },
        {
            path: "/post/:id",
            element: <Post />
        },
        {
            path: "/create",
            element: <Create />
        },
        {
          path: "/order",
          element : <Order/>
        },
        {
          path: "/terms-and-conditions",
          element: <Terms/>
        },
        {
          path: "/privacy-policy",
          element: <Privacypolicy/>
        },
        {
          path: "/RN-to-BSN",
          element: <Bsn/>
        },
        {
          path: "/MSN",
          element: <Msn/>
        },
        {
          path: "/DNP",
          element: <Dnp/>
        },
        {
          path: "/BS-in-Psychology",
          element: <Bspsy/>
        },
        {
          path: "/BS-in-Psychology-Pre-Counseling",
          element: <Bspsypre/>
        },
        {
          path: "/MS-in-Applied-Behavior-Analysis",
          element: <Msapplied/>
        },
        {
          path: "/MS-in-Clinical-Psychology",
          element: <Msclinical/>
        },
        {
          path: "/MS-in-Psychology",
          element: <Mspsy/>
        },
        {
          path: "/MS-in-School-Psychology",
          element: <Msschool/>
        },
        {
          path: "/EdS-in-School-Psychology",
          element: <Edsschool/>
        },
        {
          path: "/PhD-in-Behavior-Analysis",
          element: <Phdbehaviour/>
        },
        {
          path: "/PhD-in-Psychology",
          element: <Phdpsyc/>
        },
        {
          path: "/PsyD-in-Clinical-Psychology",
          element: <Psydclinical/>
        },
        {
          path: "/PsyD-in-School-Psychology",
          element: <Psydschool/>
        },
        {
          path: "/thank-you",
          element: <Thankyou/>
        },
        {
          path: "/capella-flexpath-rn-bsn-classes-help",
          element: <Service/>
        },
        {
          path: "/take-comprehensive-help-in-capella-flex-path-assessments",
          element: <CapellaFlexpath/>
        },
        {
          path: "/take-the-guidance-in-capella-msn-flexpath-courses",
          element: <MsnFlexpath/>
        },{
          path: "/seek-capella-university-dnp-flexpath-help",
          element: <Dnpflexpath/>
        },
        {
          path: "/capella-capstone-project-bsn-help",
          element: <CapellacapstoneBsn/>
        },
        {
          path: "/nursing-dissertation-writing-services",
          element: < Nursingdissertation />
        },
        {
          path: "/need-assistance-with-capella-flexpath-nursing",
          element: < CapellaFlexPathAssisstance />
        },
        {
          path: "/get-dnp-capstone-project-help",
          element: < DNPCapstoneProjectHelp />
        },
        {
          path: "/comprehensive-dnp-dissertation-help",
          element: < DNPDissertationHelp />
        },
        {
          path: "/capella-university-help",
          element: < CapellaUniversityHelp />
        },
        {
          path: "/reliable-nursing-homework-help-with-our-online-coursework-help",
          element: < ReliableNursingHomeworkHelp />
        },
         {
          path: "/boost-academic-performance-with-our-online-coursework-help",
          element: < BoostAcademicPerformance />
        },
        {
          path: "/pay-someone-to-take-an-online-class",
          element: < TakeMyOnlineClass />
        },
        {
          path: "/academic-assignment-help",
          element: < AcademicAssignmentHelp />
        },
        {
          path: "/assignment-writing-services",
          element: < AssignmentWritingServices />
        },
        {
          path: "/need-help-with-nursing-assignment",
          element: < NursingAssignment />
        },
        {
          path: "/nurs-fpx-4060-assessment-3-disaster-recovery-plan",
          element: < NURSFPX4060 />
        },
        {
          path: "/cheap-assignment-writing-help-services",
          element: < CheapAssignmentWriting />
        },
        {
          path: "/do-my-assignment-online",
          element: < DoMyAssignment />
        },
        {
          path: "/take-my-online-nursing-class",
          element: < OnlineNursingClass />
        },
        {
          path: "/hire-someone-to-do-your-online-class",
          element: < Hiresomeonetdoyourclass />
        },
        {
          path: "/pay-someone-to-do-my-class",
          element: < DoMyClass />
        },
        {
          path: "/get-best-online-class-help",
          element: < OnlineClassHelp />
        },
        {
          path: "/take-my-class-online-for-me",
          element: < TakeMyClassOnline />
        },
        {
          path: "/pay-someone-to-take-my-class",
          element: < Paysomeonetotakemyclass />
        },
        {
          path: "/searching-for-a-person-who-can-take-my-online-class-for-me",
          element: < Searchingforaperson />
        },
        {
          path: "/take-my-online-course-for-me",
          element: < TakeMyOnlineCourse />
        },
        {
          path: "/unlocking-academic-success-the-role-of-online-class-takers",
          element: < Unlockingacademicsuccess />
        },
        {
          path: "/pay-to-take-my-online-class",
          element: < Paytotakemyonlineclass />
        },
        {
          path: "/pay-someone-to-take-online-classes",
          element: < Paysomeonetotakeonlineclasses />
        },
        {
          path: "/do-my-class-for-me",
          element: < Domyclassforme />
        },
        {
          path: "/mba-fpx-5002-mba-leadership",
          element: < Mbafpx5002mbaleadership />
        },
        {
          path: "/mba-fpx-5006-business-strategy",
          element: < Mbafpx5006businessstrategy />
        },
        {
          path: "/mba-fpx-5008-applied-business-analytics",
          element: < Mbafpx5008appliedbusinessanalytics />
        },
        {
          path: "/mba-fpx-5010-accounting-methods-for-leaders",
          element: < Mba5010accountingmethodsforleaders />
        },
        {
          path: "/mba-fpx-5012-marketing-management",
          element: < Mbafpx5012marketingmanagement />
        },
        {
          path: "/mba-fpx-5014-applied-managerial-finance",
          element: < Mbafpx5014appliedmanagerialfinance />
        },
        {
          path: "/mba-fpx-5016-operations-management-for-leaders",
          element: < Mbafpx5016operationsmanagementforleaders />
        },
        {
          path: "/mha-fpx-5001-foundations-of-master’s-studies-in-healthcare-administration",
          element: < Mhafpx5001 />
        },
        {
          path: "/mha-fpx-5006-healthcare-finance-and-reimbursement",
          element: < Mhafpx5006 />
        },
        {
          path: "/mha-fpx-5010-strategic-healthcare-planning",
          element: < Mhafpx5010 />
        },
        {
          path: "/mha-fpx-5012-organizational-leadership-and-governance",
          element: < Mhafpx5012 />
        },
        {
          path: "/mha-fpx-5014-healthcare-quality-risk-and-regulatory-compliance",
          element: < Mhafpx5014 />
        },
        {
          path: "/nurs-fpx",
          element: < Nursfpx />
        },
        {
          path: "/nurs-fpx-4050-assessment-1",
          element: < Nursfpx4050assessment1 />
        },
        {
          path: "/nurs-fpx-4060-assessment-4",
          element: < Nursfpx4060assessment4 />
        },
        {
          path: "/nurs-fpx-4050-assessment-2",
          element: < Nursfpx4050assessment2 />
        },
        {
          path: "/nurs-fpx-4060-assessment-2",
          element: < Nursfpx4060assessment2 />
        },
        {
          path: "/nurs-fpx-4020-assessment-4",
          element: < Nursfpx4020assessment4 />
        },
        {
          path: "/nurs-fpx-4000-assessment-2",
          element: < Nursfpx4000assessment2 />
        },
        {
          path: "/nurs-fpx-4030-assessment-1",
          element: < Nursfpx4030assessment1 />
        },
        {
          path: "/nurs-fpx-4030-assessment-2",
          element: < Nursfpx4030assessment2 />
        },
        {
          path: "/nurs-fpx-4000-assessment-1",
          element: < Nursfpx4000assessment1 />
        },
        {
          path: "/nurs-fpx-4900-assessment-2",
          element: < Nursfpx4900assessment2 />
        },
        {
          path: "/mha-fpx-5006-assessment-1",
          element: < Mhafpx5006A1 />
        },
        {
          path: "/mha-fpx-5006-assessment-2",
          element: < Mhafpx5006A2 />
        },
        {
          path: "/mha-fpx-5006-assessment-3",
          element: < Mhafpx5006A3 />
        },
        {
          path: "/mha-fpx-5006-assessment-4",
          element: < Mhafpx5006A4 />
        },
        {
          path: "/nurs-fpx-8030-assessment-2",
          element: < Nursfpx8030a2 />
        },
        {
          path: "/nurs-fpx-8014-assessment-1",
          element: < Nursfpx8014a1 />
        },
        {
          path: "/nurs-fpx-8014-assessment-2",
          element: < Nursfpx8014a2 />
        },
        {
          path: "/nurs-fpx-6614-assessment-1",
          element: < Nursfpx6614a1 />
        },
       
      ]
    },
    {
        path: "/register",
        element: <Register/>,
    },
    {
        path: "/login",
        element: <Login/>,
    },
    {
      path: "/md-admin-page",
      element: <Mdadminpage/>
    }
  ]);


const App = () => {
  return (
    <>
        <RouterProvider router={router}/>
        <Helmet>
          <title>Online Course Services</title>
          <meta name='description'
          content='Discover top-notch online course assistance worldwide, еspеcially in the USA.  
          Get еxpеrt help with online classes from our 24/7 service by US writers'/>
          <meta name='keywords' content='Online class help, help with online classes, take my online class, take my class online for me, online exam help'/>
        </Helmet>
    </>
  )
}

export default App
